export default {
	en: {
		translation: {
			url: {
				inner_title: "Public URL of file to upload:",
				input_placeholder: "http://remote.site.example/images/remote-image.jpg",
			},
		},
	},
};
